

import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import {
	IdentityDocumentsWrapper,
	NavigationWrapper,
	PickerHOC,
	SoftSwitcher,
	TargetsWrapper,
	Text,
	UiWrapper,
	UserWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Header from 'layout/components/Header/Header';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import getRedirectRoute from 'helpers/redirectRoute';

export const LoadTarget = PickerHOC(
	{
		user: {
			sourceWrapper: UserWrapper,
			sourcePath: 'user',
		},
		targets: {
			sourceWrapper: TargetsWrapper,
			sourcePath: 'targets',
		},
		identityDocuments: {
			sourceWrapper: IdentityDocumentsWrapper,
			sourcePath: 'identityDocuments',
		},
	},
	LoadingScreen,
)(() => {
	const { user, targets, identityDocuments } = PickerHOC.use();

	const { useHeader, useLoading } = UiWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const [targetId, setTargetId] = useState(undefined);
	const [loading, setLoading] = useState();

	useLoading(loading, { loadingMessage: loading });
	useHeader(<Header isB2B={user?.metadata?.isB2B} />, []);
	useInitialScrollToTop();

	const ev = !targets ? 0 : !targetId ? 1 : 2;

	console.log('ev', ev);

	useEffect(() => {
		const target = targets?.[0];
		const targetId = target?.id;

		if (user && target) {
			if (user?.metadata?.isB2B) {
				localStorage.setItem('B2Flow', 'B2B');
			} else {
				localStorage.setItem('B2Flow', 'B2C');
			}

			if (targetId) {
				setTargetId(targetId);
				const { redirectRoute, params } = getRedirectRoute(
					user,
					target,
					[],
					identityDocuments,
				);
				console.log('redirectRoute', redirectRoute);
				console.log('params', params);
				CONFIG.routing.loadTarget.next(navigateTo, redirectRoute, params);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user, targets]);

	return (
		<Wrapper title={'Accediendo'}>
			<View innerWrapperSt>
				<SoftSwitcher evaluate={ev}>
					<View alignItemsStartSt>
						<Text headingPrimarySt>Obteniendo Datos</Text>
						<Text headingSecondarySt leftSt>
							Espere mientras obtenemos los datos de su simulación.
						</Text>
					</View>
					<View alignItemsStartSt>
						<Text headingPrimarySt>Sin simulación</Text>
						<Text headingSecondarySt leftSt>
							No se han encontrado datos de simulación existentes. Por favor, póngase
							en contacto con su agente.
						</Text>
					</View>
					<View alignItemsStartSt>
						<Text headingPrimarySt>Redireccionando</Text>
					</View>
				</SoftSwitcher>
			</View>
		</Wrapper>
	);
});
